import React from 'react';
import { connect } from 'react-redux';

import Fade from '@material-ui/core/Fade';
import OrangeLinearProgress from './linearProgress';

import { _ } from '../../functions/translator';

class LoadingLevel extends React.Component {
  render () {
    let levelName = ''
    if (this.props.loadingLevelId) {
        let levelId = this.props.loadingLevelId.toString()
        levelName = this.props.levelsData[levelId].attributes.name
    }

    return (
        <div>
            <Fade in={this.props.loadingLevel}>
                <div className='loading-container'>
                    <p>{_('Cargando') + ' ' + levelName + '...'}</p>
                    <OrangeLinearProgress/>
                </div>
            </Fade>
        </div>
    );
  }
}

function mapStateToProps( state ) {
    return {
        levelsData     : state.projectData.levels,
        loadingLevelId : state.loadingLevelId,
        loadingLevel   : state.switches.loadingLevel
    }
}


export default connect(mapStateToProps)(LoadingLevel);
